import React from 'react';

const PopoutButton: React.FC = () => {
  const handlePopout = () => {
    window.open('/terminal-popout.html', '_blank', 'width=800,height=600');
  };

  return (
    <button 
      onClick={handlePopout}
      className="p-1 rounded hover:bg-gray-700 flex items-center justify-center"
      title="Popout terminal"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3" />
      </svg>
    </button>
  );
};

export default PopoutButton;